import React, {Fragment} from 'react';
import b_ from 'b_';

import {Textinput} from 'client/common/components/lego';

import {selectOnFocus} from 'client/common/utils/lego';
import I18N from 'assets/i18n/brandlift-project';

import {GENDERS, AGES, getPin} from './utils';

import {MatrixProps} from './types';

const i18n = I18N.common.audienceSettings.quotas;
const b = b_.with('quotas');

export default function AllMatrix(props: MatrixProps) {
    const {quotas, error, onChange, onBlur, register, rules} = props;

    return (
        <div className={b('container')}>
            <label className={b('title')}>{i18n.type.all}, %</label>
            <div className={b('matrix', {type: 'all'})}>
                {GENDERS.map(gender => (
                    <Fragment key={gender}>
                        <h3 className={b('quota-label')}>{i18n.gender[gender]}</h3>
                        <div className={b('quota', {type: 'gender'})}>
                            {AGES.map((age, index) => {
                                const quota = quotas.find(
                                    ({gender: quotaGender, age: quotaAge}) =>
                                        quotaAge === age && quotaGender === gender
                                );

                                return (
                                    <div className={b('quota', {type: 'age'})} key={age}>
                                        <Textinput
                                            className={b('size-input')}
                                            pin={getPin(index, AGES.length)}
                                            size='m'
                                            view='dl'
                                            type='number'
                                            state={error ? 'error' : undefined}
                                            value={(quota?.sizePerc ?? 0).toFixed()}
                                            max={100}
                                            min={0}
                                            name={`quotas.gender-${gender}_age-${age}`}
                                            controlRef={register && register(rules)}
                                            onChange={e =>
                                                onChange({
                                                    age,
                                                    gender,
                                                    sizePerc: e.target.value
                                                })
                                            }
                                            onBlur={async () => onBlur()}
                                            onFocus={selectOnFocus}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </Fragment>
                ))}
                <div className={b('title-row')}>
                    {AGES.map(age => (
                        <h3 className={b('quota-title')} key={age}>
                            {i18n.age[age]}
                        </h3>
                    ))}
                </div>
            </div>
        </div>
    );
}
